import { render } from "./StepPreferences.vue?vue&type=template&id=0560f950"
import script from "./StepPreferences.vue?vue&type=script&lang=js"
export * from "./StepPreferences.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__